module.exports = __webpack_public_path__ + "static/media/icon-estoque-entrada.4b6720e2.png";